import type { ReactNode } from 'react';
import { useGraphRendererApi } from '../model/use-api';
import type { GraphRendererApi } from '../model/types';

export const GraphRendererSubscriber = ({
  children,
}: {
  children: (props: { api: GraphRendererApi }) => ReactNode;
}) => {
  const getApi = useGraphRendererApi();
  const api = getApi();

  return api ? <>{children({ api })}</> : null;
};
